import { render, staticRenderFns } from "./EditWebshop.vue?vue&type=template&id=cd07847a&scoped=true&"
import script from "./EditWebshop.vue?vue&type=script&lang=js&"
export * from "./EditWebshop.vue?vue&type=script&lang=js&"
import style0 from "./EditWebshop.vue?vue&type=style&index=0&id=cd07847a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd07847a",
  null
  
)

export default component.exports